export const AUTH_ENDPOINTS = {
    SIGNUP: `/auth/signup`,
    SIGNUP_MEMBER: `/auth/signup-member`,
    LOGIN: `/auth/login`,
    ME: `/auth/me`,
    REFRESH_TOKEN: `/auth/refresh`,
    LOGOUT: `/auth/logout`,
    RESET_PASSWORD: `/auth/reset-password`,
    FORGOT_PASSWORD: `/auth/forgot-password`,
    VALIDATE_INVITATION: `/auth/validate-invitation`,
    CONFIRM_EMAIL: (token: string) => `/auth/confirm-email?token=${token}`,
    // 2FA Endpoints
    TWO_FA_SETUP: `/auth/2fa/setup`,
    TWO_FA_VERIFY_SETUP: `/auth/2fa/verify-setup`,
    TWO_FA_VERIFY_LOGIN: `/auth/2fa/verify-login`,
    TWO_FA_DISABLE: `/auth/2fa/disable`,
    TWO_FA_STATUS: `/auth/2fa/status`,
    TWO_FA_REGENERATE_BACKUP_CODES: `/auth/2fa/regenerate-backup-codes`,
} as const;

export const TOKEN_STORAGE_KEYS = {
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
} as const;
